import { createSelector } from 'reselect';
import GlobalState from '../../../root-state';

const selectSummary = (state : GlobalState) => state.statistics.servers;

export const serverStatisticsSelector = createSelector(
    [selectSummary],
    data => data
);

